import React from "react";
import { MessageCircle, ArrowRight } from "lucide-react";
import { buildWhatsAppLink } from "../mock/mock";

const CtaStrip = () => {
  return (
    <section className="relative overflow-hidden bg-[#0B2545]">
      <div className="absolute inset-0 opacity-30">
        <img
          src="https://images.unsplash.com/photo-1620326467418-14c39a82ebe3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxzcGVlZGJvYXQlMjB0dXJxdW9pc2V8ZW58MHx8fHwxNzgzOTcxMDE4fDA&ixlib=rb-4.1.0&q=85"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0B2545] via-[#0B2545]/85 to-transparent" />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 lg:px-6 py-16 md:py-20">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div>
            <span className="inline-block bg-[#FFC93C]/20 text-[#FFC93C] text-xs font-black tracking-widest px-3 py-1 rounded-full">
              PRÊT À EMBARQUER ?
            </span>
            <h2 className="mt-4 text-3xl md:text-5xl font-black text-white leading-tight">
              Prêt à vivre <span className="text-[#FFC93C]">l&apos;expérience ?</span>
            </h2>
            <p className="mt-3 text-white/80 text-lg">
              Réservez facilement sur WhatsApp — réponse rapide, service personnalisé.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row md:justify-end gap-4">
            <a
              href={buildWhatsAppLink("Bonjour, je souhaite réserver une excursion GwadaPlaisance.")}
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center justify-center gap-3 bg-[#25D366] hover:bg-[#1EBE5D] text-white font-black px-7 py-4 rounded-xl shadow-2xl transition-all hover:-translate-y-0.5"
            >
              <MessageCircle className="h-6 w-6" fill="white" strokeWidth={0} />
              <span>RÉSERVER MAINTENANT</span>
              <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaStrip;
